import { ApplicationConfig, enableProdMode, importProvidersFrom } from '@angular/core';
import { CognitoModule } from '@shared/angular/cognito';
import { environment } from '../environments/environment';
import { SharedModule } from '@shared/common/shared.module';
import { vexThemeProviders } from './app.vex-config';
import { provideServiceWorker } from '@angular/service-worker';
import { MediaModule } from '@shared/angular/media';
import { AlertModule } from '@shared/angular/alert';
import { Amplify } from 'aws-amplify';
const { routes, cognito, endpoint, appsync } = environment;
const { userPoolId, userPoolWebClientId: userPoolClientId } = cognito;
import { TimeagoModule } from 'ngx-timeago';
import { PageTitleStrategy } from './common/strategy/title.strategy';
import { TitleStrategy } from '@angular/router';
import { provideChatStore } from './pages/chat/chat.config';
import { NgxsModule } from '@ngxs/store';
import { NotificationsState } from './layouts/components/toolbar/toolbar-notifications/state/notifications.state';

// Debug environment loading
console.log('Environment isLive:', environment.isLive);
console.log('Environment:', environment);

// Only enable production mode in actual production builds (when optimization is enabled)
// This allows Angular DevTools to work in development/staging builds even with production environment
declare const ngDevMode: boolean | undefined;
const isDevMode = typeof ngDevMode !== 'undefined' && ngDevMode;

if (environment.isLive && !isDevMode) {
    console.log('🔥 Enabling production mode (optimized build)');
    enableProdMode();
} else {
    console.log('🔧 Development mode - Angular DevTools should be available');
    console.log(
        'ngDevMode:',
        typeof ngDevMode !== 'undefined' ? ngDevMode : 'undefined',
        'isDevMode:',
        isDevMode,
    );
}

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId,
            userPoolClientId,
            loginWith: {
                oauth: cognito.oauth as never,
            },
        },
    },
    API: {
        Events: appsync.event as never,
        GraphQL: appsync.graphQL as never,
    },
});

export const appConfig: ApplicationConfig = {
    providers: [
        ...vexThemeProviders,
        importProvidersFrom(NgxsModule.forRoot([NotificationsState])),
        ...provideChatStore(),
        importProvidersFrom(TimeagoModule.forRoot()),
        importProvidersFrom(
            CognitoModule.forRoot({
                ...cognito,
                loginRoute: routes.login,
                authRoute: routes.root,
                forbiddenRoute: routes.forbidden,
            }),
        ),
        importProvidersFrom(
            SharedModule.forRoot({
                endpoint: endpoint.apiUrls,
                s3MediaUrl: endpoint.s3MediaUrl,
            }),
        ),
        importProvidersFrom(
            MediaModule.forRoot({
                endpoint: endpoint.mediaApiUrl,
                s3StreamUrl: endpoint.s3StreamUrl,
            }),
        ),
        importProvidersFrom(
            AlertModule.forRoot({
                endpoint: `${endpoint.apiUrls['user']}/auth/validate-password`,
                adminOtpEndpoint: `${endpoint.apiUrl}/otp/admin-otp/request`,
            }),
        ),
        provideServiceWorker('ngsw-worker.js', {
            enabled: environment.isLive,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        {
            provide: TitleStrategy,
            useClass: PageTitleStrategy,
        },
    ],
};
